var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"btn btn-secondary popover-anchor",attrs:{"tabindex":"0","role":"button","data-toggle":"popover","data-placement":_vm.placement,"data-trigger":"hover","title":_vm.title,"data-content":_vm.content}},[_c('i',{staticClass:"fa fa-question-circle"})])
}
var staticRenderFns = []

export { render, staticRenderFns }